<template>
  <div>
    <el-row class="upload-section">
      <el-col :span="8">
        <span class="location-label">{{ $t('uploadMenu.locations') }}</span>
        <office-dropdown :selected="adminSelectedOffice" @change="onOfficeChanged" />
      </el-col>
      <el-col :span="8">
        <div class="button-wrapper">
          <el-button class="download-button centered-object" @click="openTemplates">
            {{ $t('uploadMenu.template') }}
          </el-button>
          <span class="hint-message">
            {{ $t('uploadMenu.templateHint') }}
          </span>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="button-wrapper">
          <file-uploader
            :accepted-file="fileType"
            :office-id="adminSelectedOffice"
            class="uploader-button"
          />
        </div>
      </el-col>
    </el-row>
    <el-row class="upload-section">
      <el-col class="upload-description">
        <h2 class="upload-description__title">{{ $t('uploadMenu.descriptionTitle') }}</h2>
        <p v-html="$t('uploadMenu.description')" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { GOOGLE_SHEETS_TEMPLATES } from '@/constants';
import FileUploader from '@/components/FileUploader';
import OfficeDropdown from '@/components/OfficeDropdown';

export default {
  name: 'UploadMenu',
  components: {
    OfficeDropdown,
    FileUploader,
  },
  data() {
    return {
      fileType: '.tsv',
    };
  },
  computed: {
    ...mapGetters('user', { getUser: 'getUser' }),
    ...mapState('global', { adminSelectedOffice: 'adminSelectedOffice' }),
  },
  created() {
    this.initializeEvents();
  },
  methods: {
    onOfficeChanged(office) {
      this.$emit('officechanged', office);
    },
    openTemplates() {
      window.open(GOOGLE_SHEETS_TEMPLATES, '_blank');
    },
    ...mapActions('events', { initializeEvents: 'initializeEvents' }),
  },
};
</script>

<style scoped lang="scss">
@import '../../scss/variables';
.columnHeader {
  margin: 2em auto 1em;
}
.location-label {
  font-weight: $bold-font;
}
.button-wrapper {
  display: inline-block;
  width: 100%;
}
.download-button {
  width: 105px;
  display: block;
}
.hint-message {
  font-size: $label-description-text-size;
  text-align: center;
  color: $order-button-hint;
  margin-top: 7px;
  display: block;
}
.centered-object {
  margin-left: auto;
  margin-right: auto;
  display: block;
}
.upload-section {
  margin: 40px 200px;
  &.el-row {
    height: 100px;
  }
}
.upload-description {
  text-align: left;
  line-height: 2;
  &__title {
    margin-bottom: 20px;
    font-size: $subtitle-font-size;
    font-weight: $bold-font;
    margin-left: -20px;
  }
}
.uploader-button {
  width: 100%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/orders/UploadMenu.vue